module.exports = __webpack_public_path__ + "img/VIRTUAL_ACCOUNT_BANK_Permata.c8e4f4ae.png";